export const TOKEN_INVALID_STATUS_CODE = 2005;
